export default __webpack_public_path__ + "static/pboockvar-50b40e975e02899b227e34316ffc0389.png";